<template>
    <div class="gz-date-input gz-date-input_default">
        <Datepicker 
            class="gz-date-input__item"
            calendar-class="gz-date-input__item_inner"
            type="date"
            value-zone="local"
            v-model="date"
            :language="ru"
            @input="getDate"
            :placeholder="placeholder"
        >
        </Datepicker>
    </div>
</template>

<script>
import {ru} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'DateRangeInput',

    props: {
        value: {
            type: [Date, String]
        },
        placeholder: String
    },
    data() {
        return {
            date: this.value ? this.value : '',
            ru: ru
        }
    },
    methods: {
        getDate() {
            this.$emit('dateValue', this.date)
        }
    },
    watch: {
        value: function(newVal) {
            this.date = newVal
        }
    }
}
</script>